import React, { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { fetchProgramsAll } from "../../store/ProgramSlice";
import { AllPrograms } from "../../interfaces/Program";
import { debounce } from "lodash";
import { HealthCondition, fetchHealthData } from "../../store/UserSlice";
import { useLocation } from "react-router-dom";
import ProgramCard from "../../components/ProgramCard";

export default function ProgramsList() {

  const dispatch = useDispatch<any>();
  const location = useLocation();
  const [hId, sethId] = useState<string>(location.state?.id || '');
  const [selectedHealthConditions, setSelectedHealthConditions] = useState<string>("");
  const [changeText, setChangeText] = useState(true);

  const programsAll = useSelector((state: RootState) => state.programs.data || ([] as AllPrograms[]));
  const healthConditions = useSelector((state: RootState) => state.user.data || []) as HealthCondition[];
  setTimeout(function () {
    const hIdCheckbox = document.getElementById(hId) as HTMLInputElement;
    if (hIdCheckbox) {
      hIdCheckbox.checked = true;
    }
  }, 300);

  useEffect(() => {
    dispatch(fetchHealthData());
    if (hId || !selectedHealthConditions) {
      dispatch(fetchProgramsAll({ search: "", healthCondition: hId }));
    } else {
      dispatch(fetchProgramsAll({ search: "", healthCondition: selectedHealthConditions }));
    }
  }, [dispatch, selectedHealthConditions, hId]);

  const handleSearch = (query: string) => {
    dispatch(fetchProgramsAll({ search: query, healthCondition: selectedHealthConditions }));
  };

  const debouncedSearch = debounce(handleSearch, 500);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChangeText(e.target.value === '');
    const query = e.target.value;
    debouncedSearch(query);
    // handleSearch(query); // Trigger search on every change
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setChangeText(e.target.value === '');
  };
  const handleHealthConditionChange = (e: ChangeEvent<HTMLInputElement>) => {
    const healthConditionName = e.target.name;
    sethId("");
    const hIdCheckbox = document.getElementById(hId) as HTMLInputElement;

    if (hIdCheckbox) {
      hIdCheckbox.checked = false;
    }

    if (e.target.id == "all") {
      const allHealthConditions = document.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

      setSelectedHealthConditions("");

      allHealthConditions.forEach(condition => {
        (condition as HTMLInputElement).checked = false;
      });
      const allCheckbox = document.getElementById("all") as HTMLInputElement;
      if (allCheckbox) {
        allCheckbox.checked = true;
      }
      dispatch(fetchProgramsAll({ search: "", healthCondition: selectedHealthConditions }));
    } else {

      if (e.target.checked) {
        setSelectedHealthConditions((prevConditions) =>
          prevConditions ? prevConditions + "," + healthConditionName : healthConditionName
        );
        const allCheckbox = document.getElementById("all") as HTMLInputElement;
        if (allCheckbox) {
          allCheckbox.checked = false;
        }

      } else {
        setSelectedHealthConditions((prevConditions) =>
          prevConditions
            ? prevConditions.replace(new RegExp(healthConditionName + ",?\\s?"), "")
            : ""
        );
        const allCheckbox = document.getElementById("all") as HTMLInputElement;
        if (allCheckbox) {
          allCheckbox.checked = false;
        }
      }
    }

  };

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleButtonClick = () => {
    setDropdownVisible(!dropdownVisible);
  };


  useEffect(() => {
    // Dispatch the fetchHealthData action to fetch health data
    dispatch(fetchHealthData());
  }, [dispatch]);

  localStorage.removeItem('SetSlug');
  return (
    <>
      <div className="relative">
        <div
          className="bg-cover bg-center text-center text-white p-8 "
          style={{
            backgroundImage: `url("./images/innerb.jpg")`,
          }}
        >
          <div className="text-center pt-40 pb-28">
            <h1 className="text-2xl md:text-4xl font-bold">Programmes</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-10 px-4 md:px-6">
        <div className="flex flex-wrap items-center gap-4 mb-8">
          <form className="items-start w-auto" onSubmit={(e) => e.preventDefault()}>
            <div className="relative">
              <input
                type="text"
                placeholder=""
                onChange={handleChange}
                className="border rounded-md py-2 w-60 md:w-96 px-4 focus:outline-none placeholder-[#B0BEC5] bg-[#F5F7F8]"
              />
              {changeText && (
                <div
                  className="absolute inset-y-0 left-0 pt-1 pl-4 flex items-center pointer-events-none">
                  <img src='./images/Vector.png' className="mx-auto mb-1 " width={18}
                    alt="search" /> <span className='pl-2 leading-3 text-[#B0BEC5]'>Search</span>
                </div>
              )}
            </div>
          </form>
          <div className="relative">
            <button
              id="dropdownDefault"
              data-dropdown-toggle="dropdown"
              className="border rounded-md py-2 text-[#263238] px-4 focus:outline-none placeholder-[#B0BEC5] bg-[#F5F7F8] hover:font-semibold flex items-center"
              type="button"
              onClick={handleButtonClick}
            >
              Filter
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline ml-4">
                <path d="M8.23461 15.6045H1.00049" stroke="#263238" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M19.2353 15.6045C19.2353 17.195 17.9459 18.4845 16.3553 18.4845C14.7648 18.4845 13.4753 17.195 13.4753 15.6045C13.4753 14.0127 14.7648 12.7245 16.3553 12.7245C17.9459 12.7245 19.2353 14.0127 19.2353 15.6045Z" stroke="#263238" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.0001 3.88H19.2354" stroke="#263238" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M1 3.88C1 5.47176 2.28941 6.76 3.88 6.76C5.47059 6.76 6.76 5.47176 6.76 3.88C6.76 2.28941 5.47059 1 3.88 1C2.28941 1 1 2.28941 1 3.88Z" stroke="#263238" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            {dropdownVisible && (
              <div id="dropdown" className="absolute left-0 z-20 w-56 p-4 mt-2 bg-white rounded-md shadow-lg border border-gray-100">
                <ul className="space-y-4 text-sm" aria-labelledby="dropdownDefault">
                  <li className="flex items-center">
                    <input
                      id="all"
                      type="checkbox"
                      value=""
                      onChange={handleHealthConditionChange}
                      className="w-5 h-5 bg-[#B4804A] border-[#A5A6A9] rounded text-primary-600 focus:ring-primary-500 cursor-pointer"
                    />

                    <label className="ml-3 text-base font-medium text-gray-900 cursor-pointer" htmlFor="all">All</label>
                  </li>
                  {healthConditions.map((healthCondition: HealthCondition) => (
                    <li className="flex items-center" key={healthCondition.id}>
                      <input
                        id={healthCondition.id}
                        name={healthCondition.id}
                        type="checkbox"
                        value=""
                        className="w-5 h-5 bg-gray-100 border-[#A5A6A9] rounded text-primary-600 focus:ring-primary-500 cursor-pointer"
                        onChange={handleHealthConditionChange}
                      />

                      <label className="ml-3 text-base font-medium text-[#263542] capitalize cursor-pointer" htmlFor={healthCondition.id}>{healthCondition.name}</label>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        {programsAll.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {programsAll.map((programs: AllPrograms) => (
              <div key={programs.id} className="h-full">
                <ProgramCard program={programs} />
              </div>
            ))}
          </div>
        )}
      </div>

    </>
  );
}

